export const jobTabs = [
  {
    id: 'summary',
    title: 'Summary',
  },
  {
    id: 'service-details',
    title: 'Service Invoice Details',
  },
  {
    id: 'service-payment',
    title: 'Payment',
  },
  {
    id: 'tickets',
    title: 'Tickets'
  },
  {
    id: 'emails',
    title: 'Emails',
  },
  {
    id: 'sms',
    title: 'SMS',
  },
];
